export enum QuickbooksUpdateTypeEnum {
  INVENTORY_ADD = 'inventory_add',
  PURCHASE_ORDER_ADD = 'purchase_order_add'
}

export const QuickbooksUpdateTypeTranslation: { [index: string]: string } = {
  [QuickbooksUpdateTypeEnum.INVENTORY_ADD]: 'Adjust Inventory',
  [QuickbooksUpdateTypeEnum.PURCHASE_ORDER_ADD]: 'Send Purchase Order'
}
